export default "__VITE_ASSET__Cf4EBYJn__"